import * as dtos from "@/models/dtos";

export default class CustomThemeBuilder {
  getDefaultTheme = (): dtos.CustomTheme => {
    const defaultTheme = new dtos.CustomTheme({
      button: {
        backgroundColor: "#2522BA",
        textColor: "#FFFFFF",
        borderRadius: "rounded-md",
      },
      backgroundColor: {
        mainContent: "#FFFFFF",
        footer: "#333333",
        socialMedia: "#EFF0FB",
      },
      textColor: {
        workAtText: "#333333",
        contactText: "#868BFC",
        detailText: "#747474",
        otherText: "#333333",
        footerText: "#FFFFFF",
      },
      icon: {
        footerIcon: "#FFFFFF",
        positionIcons: "#62B5E5",
        positionIcon1: "#8A8DE5",
        positionIcon2: "#F85E8D",
        positionIcon3: "#89C5CC",
        positionIcon4: "#9C55F5",
        socialMedia: "#868BFC",
      },
    });
    return defaultTheme;
  };
}
